// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface ComputeMaxWaterdepthInput
 */
export interface ComputeMaxWaterdepthInput {
  /**
   *
   */
  scenario: RanaFile;
  /**
   *
   */
  threshold?: number;
}

/**
 * Check if a given object implements the ComputeMaxWaterdepthInput interface.
 */
export function instanceOfComputeMaxWaterdepthInput(
  value: object
): value is ComputeMaxWaterdepthInput {
  if (!("scenario" in value) || value["scenario"] === undefined) return false;
  return true;
}

export function ComputeMaxWaterdepthInputFromJSON(json: any): ComputeMaxWaterdepthInput {
  return ComputeMaxWaterdepthInputFromJSONTyped(json, false);
}

export function ComputeMaxWaterdepthInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ComputeMaxWaterdepthInput {
  if (json == null) {
    return json;
  }
  return {
    scenario: RanaFileFromJSON(json["scenario"]),
    threshold: json["threshold"] == null ? undefined : json["threshold"],
  };
}

export function ComputeMaxWaterdepthInputToJSON(json: any): ComputeMaxWaterdepthInput {
  return ComputeMaxWaterdepthInputToJSONTyped(json, false);
}

export function ComputeMaxWaterdepthInputToJSONTyped(
  value?: ComputeMaxWaterdepthInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    scenario: RanaFileToJSON(value["scenario"]),
    threshold: value["threshold"],
  };
}
